
import { __ } from "src/libs/utilities"
import Feed from "src/modules/pe-basic-module/views/core/Feed"
import useAds from "../../hooks/useAds"
import ToposSingleNews from "./ToposSingleNews"

const ToposNews = () : JSX.Element => {
  useAds()  
  return <div className="w-100 p-md-4">
    <div className="container px-1">
      <div className="lead-md pt-4 pb-2 h">{__("News")}</div>
      <Feed
        data_type="Ad"
        component={ToposSingleNews}
        paging={` `}
        land_id="all"
        includeFields={`land{id title}`}
        class_name="row"
        topPagiHide
        pagiLabelStyle={{ isHideNumerics: true }}
        params={{
          col: 2,
          pageCount: 6
        }}
      /> 
    </div> 
  </div>
   
}

ToposNews.propTypes = {}

export default ToposNews